import type { ListingLocaleOverrides } from '../base';
import { AZOverrides } from './AZ';
import { CAOverrides } from './CA';
import { DCOverrides } from './DC';
import { FLOverrides } from './FL';
import { GAOverrides } from './GA';
import { KYOverrides } from './KY';
import { MAOverrides } from './MA';
import { MDOverrides } from './MD';
import { NCOverrides } from './NC';
import { NJOverrides } from './NJ';
import { NVOverrides } from './NV';
import { NYOverrides } from './NY';
import { OHOverrides } from './OH';
import { OROverrides } from './OR';
import { SCOverrides } from './SC';
import { TXOverrides } from './TX';
import { VAOverrides } from './VA';
import { WAOverrides } from './WA';

export const overrides: Record<string, ListingLocaleOverrides> = {
  AZ: AZOverrides,
  CA: CAOverrides,
  DC: DCOverrides,
  FL: FLOverrides,
  GA: GAOverrides,
  KY: KYOverrides,
  MA: MAOverrides,
  MD: MDOverrides,
  NC: NCOverrides,
  NJ: NJOverrides,
  NV: NVOverrides,
  NY: NYOverrides,
  OH: OHOverrides,
  OR: OROverrides,
  SC: SCOverrides,
  TX: TXOverrides,
  VA: VAOverrides,
  WA: WAOverrides,
};
